import React from "react";
import {useFormikContext} from "formik";
import moment from "moment";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import {Button, Grid, Typography} from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import {createStyles, makeStyles} from "@material-ui/core/styles";
import {ErrorCommon, FormikValues, TextFieldCommon} from "../../formikFormInputs";
import {usePolicyContext} from "./PolicyContext";
import {ContributionField} from "./FlexiPayments";
import {PaymentFrequency, PaymentStatus} from "./index";
import { DMC } from "./FlexiPayments";

const useStyles = makeStyles(() =>
        createStyles({
            heading: {
                flexShrink: 0,
                marginBottom: 0,
            },
        }),
);

type PaymentBreakdownAnnualProps = {
    fields: ContributionField[];
    frequency: string;
    handlePaymentSave: () => Promise<void>;
    paymentData: any;
    saveIndexIds: number[];
    setSaveIndexIds: Function;
    year: number;
}

const PaymentBreakdownAnnual = (props: PaymentBreakdownAnnualProps) => {
    const classes = useStyles();
    const {policy} = usePolicyContext();
    const {values, handleChange, setFieldValue, errors, touched}: FormikValues = useFormikContext();
    const {fields, frequency, handlePaymentSave, paymentData, saveIndexIds, setSaveIndexIds, year} = props;
    const panelName = `annual${year}`;
    const [expanded, setExpanded] = React.useState<string>('');


    React.useEffect(() => {
        if (policy && policy.flexiPayments && policy.flexiPayments.length > 0) {
            policy.flexiPayments.map((payment: any) => {
                setFieldValue(`${DMC}.${payment.inx}.amount`, payment.amount)
                setFieldValue(`${DMC}.${payment.inx}.date`, moment(payment.date).format("YYYY-MM-DD"))
                setFieldValue(`${DMC}.${payment.inx}.paymentId`, payment.paymentId)
                setFieldValue(`${DMC}.${payment.inx}.status`, payment.status)
                setFieldValue(`${DMC}.${payment.inx}.inx`, payment.inx)
            })
        }
    }, [expanded])

    return (
            frequency === PaymentFrequency.Annual &&
            paymentData && Object.keys(paymentData).length > 0 && Object.keys(paymentData) ?
                    <ExpansionPanel
                            expanded={expanded === panelName}
                            onChange={(_e, expanded) => setExpanded(expanded ? panelName : '')}
                            style={{marginBottom: '15px'}}
                    >
                        <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon/>}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                        >
                            <Typography className={classes.heading} variant="body1">
                                Annual Contributions
                            </Typography>
                        </ExpansionPanelSummary>

                        <ExpansionPanelDetails>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    {
                                        fields.map((f, i) => {
                                            const onBlurChange = (e: React.SyntheticEvent) => {
                                                setSaveIndexIds([...saveIndexIds, paymentData["inx"]])
                                                return handleChange(e);
                                            };
                                            const name = `${DMC}.${paymentData["inx"]}.${f.name}`;
                                            f['disabled'] = paymentData.status != PaymentStatus.PaymentUpcoming; // Payment status not upcoming
                                            f['disablePast'] = !(paymentData.status != PaymentStatus.PaymentUpcoming)
                                            return (
                                                    <Grid item xs={10} md={5} xl={5} key={i} className="mb15">
                                                        <TextFieldCommon
                                                                {...f}
                                                                id={name}
                                                                name={name}
                                                                values={values}
                                                                onBlur={onBlurChange}
                                                                onChange={handleChange}
                                                                cb={onBlurChange}
                                                        />
                                                        <ErrorCommon errors={errors} name={f.name} touched={touched}/>
                                                    </Grid>
                                            );
                                        })
                                    }
                                </Grid>
                                <Button
                                        className="ml20"
                                        color="primary"
                                        onClick={() => handlePaymentSave()}
                                        size="small"
                                        type="submit"
                                        variant="contained"
                                >
                                    Save Changes
                                </Button>
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel> :
                    <></>
    );
};

export default PaymentBreakdownAnnual;